import { RootState } from "interfaces/generics.type";
import { useSelector } from "react-redux";

function FallBack() {
  return <span />;
}

function withShoppingCartState(WrappedComponent: any, FallbackComponent = FallBack) {
  function HOC(props: any) {
    const hasRefreshed = useSelector((state: RootState) => state.shoppingCart.hasRefreshed);
    const isLoading = useSelector((state: RootState) => state.garage.isLoading);
    if (hasRefreshed === true && isLoading === false) {
      return (
        <WrappedComponent {...props} />
      );
    }
    return (
      <FallbackComponent
        {...props}
      />
    );
  }
  return HOC;
}

export default withShoppingCartState;
